import React, { useMemo } from 'react';
import { useStopSalesList } from '../../../contextsProperty/ContextStopSales';
import useCalendar from '../../../../customHooks/useCalendar';
import {
    CalendarEvent,
    CalendarView,
} from '../../../../types/calendar/calendarTypes';
import { IStopSaleListState } from '../../../../types/stopSale/stopSalesTypes';
import StopSaleEvent from './StopSalesEvent';
import Calendar from '../../../../components/calendar/Calendar';

const StopSalesCalendar = () => {
    const { items, isLoading } = useStopSalesList();
    const {
        calendarRef,
        activeView,
        changeView,
        goToDate,
        prev,
        next,
        today,
        idHoveredEvent,
        hoverEvent,
        unhoverEvent,
    } = useCalendar({
        initialView: CalendarView.MONTH,
    });

    const events: CalendarEvent<IStopSaleListState>[] = useMemo(() => {
        return items.map(item => {
            return {
                id: item.Id,
                title: `${item.FromDate} - ${item.ToDate}`,
                start: item.FromDate,
                end: item.ToDate,
                allDay: true,
                extendedProps: {
                    ...item,
                },
            };
        });
    }, [items]);

    const renderEvent = (event: CalendarEvent<IStopSaleListState>) => {
        return (
            <StopSaleEvent
                event={event}
                idHoveredEvent={idHoveredEvent}
                hoverEvent={hoverEvent}
                unhoverEvent={unhoverEvent}
            />
        );
    };

    return (
        <div className='flex-grow overflow-y-auto'>
            <Calendar
                calendarRef={calendarRef}
                events={events}
                renderEvent={renderEvent}
                eventColor={'var(--background)'}
                isLoading={isLoading}
                onNext={next}
                onPrev={prev}
                onToday={today}
                onViewChange={changeView}
                onGoToDate={goToDate}
                activeView={activeView}
            />
        </div>
    );
};

export default StopSalesCalendar;
